module.exports = __webpack_public_path__ + "static/media/solution-ic-4.b80c8ed2.svg";